module.exports = __webpack_public_path__ + "static/media/tab03img03.35ccee7d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/04/02/assets/tab03img03.mp4
// module id = 538
// module chunks = 0